import { type NavigationItem, useNavigationItems as useBaseNavigationItems } from '#layers/core/app/composables/useNavigationItems';

export function useNavigationItems() {
  const { isPresaleActive } = usePresale();
  const { t } = useI18n();
  const localePath = useLocalePath();
  const baseNavigationItems = useBaseNavigationItems();

  const subscriptionItem = computed<NavigationItem>(() => ({
    id: 'subscription',
    label: t('ui.layout.nav.link.subscription.label'),
    icon: 'star',
    to: localePath('/subscription'),
  }));

  const tripsIdx = computed(() => baseNavigationItems.navigationItems.value.findIndex(item => item.id === 'trips'));

  const subscriptionItems = computed<NavigationItem[]>(() => {
    const base = baseNavigationItems.navigationItems.value;
    return [
      ...base.slice(0, tripsIdx.value + 1),
      subscriptionItem.value,
      ...base.slice(tripsIdx.value + 1),
    ];
  });

  // Presale: trips excluded
  const excludedItems = new Set(['trips']);
  const preSalesItems = computed<NavigationItem[]>(() => subscriptionItems.value.filter(item => !excludedItems.has(item.id)));

  const navigationItems = computed(() => (isPresaleActive.value ? preSalesItems.value : subscriptionItems.value));

  return { navigationItems };
}
